import { render } from "./BrowserViewerPresentation.vue?vue&type=template&id=bd14480e&scoped=true"
import script from "./BrowserViewerPresentation.vue?vue&type=script&lang=js"
export * from "./BrowserViewerPresentation.vue?vue&type=script&lang=js"

import "./BrowserViewerPresentation.vue?vue&type=style&index=0&id=bd14480e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd14480e"]])

export default __exports__